/* =========================================================================================
    Description: danh sách các enum dùng chung cho toàn hệ thống
    Author: DNThang
    CreatedDate: 02.07.2019
=========================================================================================:*/
export const MSEnum = {
    //Type cho control messageToast
    //Created by LTDAT(04.01.2021)
    msgToastType: { Success: 1, Warning: 2, Error: 3, Confirm: 4 },
    systemImport: {
        /// <summary>
        /// Misa dịch vụ
        /// </summary>
        MisaService: 1, /// </summary> /// Misa hàng hóa /// <summary>
        MisaMerchandise: 2, /// </summary> /// SME2012 dịch vụ /// <summary>
        SME2012Service: 25, /// </summary> /// SME2012 hàng hóa (Thanh toán ngay) /// <summary>
        SME2012PayMerchandise: 26, /// </summary> /// SME2012 hàng hóa (Chưa thanh toán) /// <summary>
        SME2012NotPayMerchandise: 27, /// </summary> /// Fast dịch vụ /// <summary>
        FastService: 3, /// </summary> /// Fast hàng hóa /// <summary>
        FastMerchandise: 4
    },
    newInvoiceExport: {
        InvoiceServiceMOKA: 17, // /// </summary> // /// SmartPro dịch vụ // /// <summary> /// <summary>
        // SmartProService :  5,
        // /// <summary>
        // /// SmartPro hàng hóa
        // /// </summary>
        // SmartProMerchandise :  6,
        // /// <summary>
        /// Easybook dịch vụ
        /// </summary>
        // EasybookService :  9,
        // /// <summary>
        // /// Easybook hàng hóa
        // /// </summary>
        // EasybookMerchandise :  10,
        // /// <summary>
        // /// Mẫu SAP
        // /// </summary>
        // TemplateSAP : 11,
        /// <summary>
        /// Hóa đơn dịch vụ của MOKA
        /// </summary>
        /// HĐ mua hàng của MOKA
        /// </summary>
        InvoiceSaleMOKA: 18,
        InvoiceMOKA: 19
    },
    invoicesMassan: {
        /// <summary> /// </summary> /// Phiếu chi của MOKA /// <summary>
        /// Bảng kê HHDV mua vào của Massan
        /// </summary>
        InvoiceMassan: 21
    },
    exportInvoiceEnum: { InvoiceList: 1, InvoiceStatement: 2, ImportApp: 3 },
    exportOutInvoiceEnum: { InvoiceList: 1, ImportApp: 2 },
    lstImportVal: { InputInvoice: 7 },
    lstImportOutInvoiceVal: { OutInvoiceList: 35 },
    lstInvoiceStatement: { ListInvoiceBuyer: 8, InvoiceBuyer: 20 },
    InvoiceReportList: {
        /// <summary> /// Bảng kê hàng hóa dịch vụ tổng hợp /// <summary> /// </summary> /// Bảng kê hàng hóa dịch vụ chi tiết /// <summary>
        /// Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ mua vào theo Mẫu số: 01-1/HT (Thông tư số 80/2021/TT-BTC)
        /// </summary>
        ListInvoiceBuyer802021: 22
    },
    ConfirmGoodsVatRate: { ConfirmGoodsVatRateList: 23 },
    listImport: { InvoiceList: 1, ExportToOtherApp: 2 },
    outInvoiceExport: {
        /// <summary>
        /// MISA AMIS Kế toán - Hàng hóa
        /// </summary>
        InvoiceSaleAmis: 12,
        ServiceAmis: 13,
        InvoiceListAmis: 14,
        SMEInvoiceSale: 15,
        SMESale: 16
    },
    DeclarationExport: { DeclarationList: 29, DeclarationDetail: 30 },
    DeclarationExportAccounting: { MisaSmeMerchandise: 31 },
    UploadStatus: {
        /// <summary> /// </summary> /// MISA AMIS Kế toán - Dịch vụ /// <summary> /// </summary> /// MISA AMIS Kế toán - Danh sách hóa đơn /// <summary> /// </summary> /// MISA SME Hóa đơn bán hàng /// <summary> /// </summary> /// MISA SME Bán hàng /// <summary>
        /// Chưa hỗ trợ
        /// </summary>
        Unsupport: -1,
        Undefined: 0,
        Unchecked: 1,
        Valid: 2,
        Invalid: 3,
        Uncompleted: 4,
        Duplicated: 10,
        Expired: 11,
        OutOfQuantity: 12,
        NotFound: 13,
        Error: 14,
        MaxLength: 15,
        InvalidFormat: 16,
        FileFailedProcessed: 17,
        NotNeedCheck: 31
    },
    /** /// </summary> /// Chưa xác định /// <summary> /// </summary> /// Hóa đơn mới, chưa kiểm tra /// <summary> /// </summary> /// Hóa đơn hợp lệ /// <summary> /// </summary> /// Hóa đơn không hợp lệ /// <summary> /// </summary> /// Hóa đơn chưa kiểm tra được hết các chỉ tiêu /// <summary> /// </summary> /// Hóa đơn bị trùng /// <summary> /// </summary> /// Hết hạn sử dụng /// <summary> /// </summary> /// Hết số lượng sử dụng /// <summary> /// </summary> /// Không tìm thấy hóa đơn /// <summary> /// </summary> /// Lỗi file /// <summary> /// </summary> /// Vượt quá dung lượng cho phép /// <summary> /// </summary> /// Định dạng không được hỗ trợ /// <summary> /// </summary> /// Xử lý tệp thất bại /// <summary> /// </summary> /// Không kiểm tra /// <summary>
     * Các kiểu dữ liệu (maping với bảng DBOption dùng để parse dữ liệu)
     * CreatedBy DNThang - 29.11.2019
     */
    DataType: {
        /**
         * Không xác định
         */
        None: 0,
        String: 1,
        Boolean: 2,
        DateTime: 3,
        /**
         * Dữ liệu integer
         */
        Number: 4,
        Decimal: 5,
        Guid: 10
    },
    /**
     * Các kiểu định dạng của MISA
     * created by hoant 05.09.2019
     * DNThang - 09.09.2019: Sửa tên từ EnumNumericType thành FormatType (và cho giá trị None = 0)
     * NVLam - 16/09/2019: Thêm các kiểu dữ liệu khác ngoài số
     */
    FormatType: {
        /// <summary>
        /// Loại mà không xử lý gì cả
        /// </summary>
        /// <remarks></remarks>
        None: 0,
        UnitPrice: 1,
        Amount: 2,
        Rate: 3,
        ExchangeRate: 4,
        UnitPriceOC: 5,
        AmountOC: 6,
        Allocation: 7,
        QuantityConvert: 8,
        WorkDay: 10,
        Quantity: 11,
        Text: 12,
        Checkbox: 13,
        Date: 14,
        List: 15,
        Time: 16,
        Join: 17,
        GroupItem: 18,
        DateTime: 19,
        Number: 20,
        TaxPeriod: 21,
        TaxStatus: 22,
        PassWord: 23,
        NumberString: 24,
        Html: 99,
        Enum: 100,
        EnumOne: 101,
        VatRate: 102
    },
    /** //Số công ///Số lượng //Kiểu chữ //Kiểu tích chọn //Kiểu ngày tháng //Kiểu danh sách //Kiểu thời gian // Join mảng theo dấu ; //Group Item //Kiểu ngày/tháng/năm có giờ //Kiểu số không có định dạng sau dấu phẩy //Định dạng dữ liệu kỳ tính thuế //Định dạng status thuế //Kiểu mật khẩu //Định dạng dữ liệu html //Kiểu enum //Kiểu enum chọn 1 // Format cho thuế suất ///Đơn giá ///Định dạng cho tiền hạch toán ///Hệ số, Tỷ lệ ///Thành tiền quy đổi ///----------------------------------- ///Đơn giá ///Tỷ giá ///Định dạng cho tiền ngoai te ///Số lượng ///Thành tiền nguyên tệ ///Hệ số, tỷ lệ phân bổ ///-----------------------------------
     * Trạng thái làm việc của form
     * CreatedBy DNThang - 25.12.2019
     */

    FormState: {
        /**
         * Mode View
         */
        View: 0,
        /**
         * Thêm
         */
        Add: 1,
        /**
         * Sửa
         */
        Edit: 2,
        /**
         * Nhân bản
         */
        Duplicate: 3,
        /**
         * Thêm nhanh
         */
        QuickAdd: 4
    },
    /**
     * Các chế độ editmode
     * Mapping với server side
     */
    ModelState: {
        /**
         * Mode View
         */
        None: 0,
        /**
         * Thêm
         */
        Insert: 1,
        /**
         * Sửa
         */
        Update: 2,
        /**
         * Xóa
         */
        Delete: 3,
        /**
         * Nhân bản
         */
        Duplicate: 4,
        /**
         * Thêm nhanh
         */
        QuickAdd: 5,
        /**
         * Nhập khẩu
         */
        Import: 6
    },
    TypeInvoice: { Invoice: 0, Receipt: 1, Ticket: 2 },
    InvoiceStatus: {
        All: 0,
        WaitChecking: 1,
        Valid: 2,
        Invalid: 16,
        NoHasPdf: 999,
        InvoiceDraft: 8,
        NoHasXml: 998,
        Risky: 30,
        NoRisky: 29,
        NotNeedCheck: 31
    },
    OutInvoiceStatus: { All: 0, HasXml: 997, NoHasXml: 998 },
    AcceptInvoiceStatus: { Wait: 0, Accept: 1, Reject: 2 },
    /** //Cờ chỉ dùng để lọc hóa đơn không có bản thể hiện pdf // Cờ lọc hóa đơn không có file xml, //Cờ đánh dấu lọc hóa đơn có file xml // Cờ lọc hóa đơn không có file xml // WaitChecking: 3,
     * Trạng thái hoạt động của doanh nghiệp
     */
    ActiveStatus: {
        All: 999,
        Active: 1,
        Inactive: 2,
        WaitingUpdateIdentityCode: 10,
        WaitingVerification: 9,
        NotSure: 0
    },
    ReportInvoiceStatus: { All: 0, Adjust: 5, Replace: 4 },
    CheckingStatus: {
        /// <summary> //Tất cả //Sai sót //Thay thế
        /// Gặp lỗi trong quá trình check (-1)
        /// </summary>
        ErrorOnChecking: -1, /// Chưa kiểm tra (0) /// <summary>
        /// </summary>
        Unchecked: 0, /// Hợp lệ (1) /// <summary>
        /// </summary>
        Valid: 1, /// Không rõ trạng thái /// <summary>
        /// </summary>
        Unknown: 8, /// Không hợp lệ (16) /// <summary>
        /// </summary>
        Invalid: 16, /// Không kiểm tra /// <summary>
        /// </summary>
        NotCheck: 32
    },
    /// <summary>
    /// Mã trạng thái chứng thư số do RD trả về
    /// </summary>
    RdCertificateStatusCode: {
        /// Chứng thư hợp lệ (0)
        Valid: 0,
        /// Chứng thư bị thu hồi (1)
        Revoked: 1,
        /// Không xác định được trạng thái chứng thư (2)
        Unknown: 2,
        /// Chứng thư bị tạm khóa (3)
        Suspended: 3,
        /// Lỗi hoặc trạng thái không xác định từ RD (4)
        Error: 4
    },
    SubType: {
        /// <summary>
        /// Doanh nghiệp
        /// </summary>
        Enterprise: 1,
        ServiceAccountCompany: 2,
        ServiceAccountIndividual: 3
    },
    UserStatus: { Active: 1, InActive: 0 },
    Role: { Admin: 1, User: 2 },
    Event: {
        None: 0,
        Add: 1,
        Edit: 2,
        Delete: 3,
        ShowMess: 4,
        Download: 5,
        View: 6,
        Duplicate: 7,
        Accept: 8,
        Close: 9,
        Sync: 10,
        Connect: 11,
        Disconnect: 12,
        ReloadNow: 13,
        Check: 14,
        Save: 15,
        Cancel: 16
    },
    EventInvoice: {
        None: 0,
        AcceptInvoice: 1,
        RejectInvoice: 2,
        SendMailSeller: 3,
        SendMailMisa: 4,
        Delete: 5,
        Restore: 6,
        Accounted: 7,
        UnAccounted: 8,
        MoveInvoice: 9,
        Edit: 10,
        PaymentInvoice: 11,
        ViewDetail: 12,
        SyncNow: 13,
        ConnectAgain: 14,
        UnConnect: 15,
        ConnectNow: 16,
        ConnectNowV2: 17,
        UnPaymentInvoice: 18,
        Viewed: 19,
        UnViewed: 20,
        Noted: 21,
        UpdateStatus: 22,
        Print: 23,
        Download: 24,
        CheckAgain: 25,
        ClassificationCost: 26,
        UpdateCostType: 27,
        AcceptCheckingResult: 28,
        ViewInvoiceAdjust: 29,
        ViewInvoiceReplacement: 30,
        PrintCheckingResult: 31,
        ChangeReceiveEmail: 32,
        UpdateInvoiceDetail: 33,
        SyncAgain: 34,
        DownloadOriginal: 35,
    },
    TypeOfMoney: { VND: 1, USD: 2 },
    Month: {
        Month1: 1,
        Month2: 2,
        Month3: 3,
        Month4: 4,
        Month5: 5,
        Month6: 6,
        Month7: 7,
        Month8: 8,
        Month9: 9,
        Month10: 10,
        Month11: 11,
        Month12: 12
    },
    Quarter: { Quarter1: 1, Quarter2: 2, Quarter3: 3, Quarter4: 4 },
    StatusCode: {
        Status100Continue: 100,
        Status412PreconditionFailed: 412,
        Status413PayloadTooLarge: 413,
        Status413RequestEntityTooLarge: 413,
        Status414RequestUriTooLong: 414,
        Status414UriTooLong: 414,
        Status415UnsupportedMediaType: 415,
        Status416RangeNotSatisfiable: 416,
        Status416RequestedRangeNotSatisfiable: 416,
        Status417ExpectationFailed: 417,
        Status418ImATeapot: 418,
        Status419AuthenticationTimeout: 419,
        Status421MisdirectedRequest: 421,
        Status422UnprocessableEntity: 422,
        Status423Locked: 423,
        Status424FailedDependency: 424,
        Status426UpgradeRequired: 426,
        Status428PreconditionRequired: 428,
        Status429TooManyRequests: 429,
        Status431RequestHeaderFieldsTooLarge: 431,
        Status451UnavailableForLegalReasons: 451,
        Status500InternalServerError: 500,
        Status501NotImplemented: 501,
        Status502BadGateway: 502,
        Status503ServiceUnavailable: 503,
        Status504GatewayTimeout: 504,
        Status505HttpVersionNotsupported: 505,
        Status506VariantAlsoNegotiates: 506,
        Status507InsufficientStorage: 507,
        Status508LoopDetected: 508,
        Status411LengthRequired: 411,
        Status510NotExtended: 510,
        Status410Gone: 410,
        Status408RequestTimeout: 408,
        Status101SwitchingProtocols: 101,
        Status102Processing: 102,
        Status200OK: 200,
        Status201Created: 201,
        Status202Accepted: 202,
        Status203NonAuthoritative: 203,
        Status204NoContent: 204,
        Status205ResetContent: 205,
        Status206PartialContent: 206,
        Status207MultiStatus: 207,
        Status208AlreadyReported: 208,
        Status226IMUsed: 226,
        Status300MultipleChoices: 300,
        Status301MovedPermanently: 301,
        Status302Found: 302,
        Status303SeeOther: 303,
        Status304NotModified: 304,
        Status305UseProxy: 305,
        Status306SwitchProxy: 306,
        Status307TemporaryRedirect: 307,
        Status308PermanentRedirect: 308,
        Status400BadRequest: 400,
        Status401Unauthorized: 401,
        Status402PaymentRequired: 402,
        Status403Forbidden: 403,
        Status404NotFound: 404,
        Status405MethodNotAllowed: 405,
        Status406NotAcceptable: 406,
        Status407ProxyAuthenticationRequired: 407,
        Status409Conflict: 409,
        Status422UnprocessableEntity: 422,
        Status511NetworkAuthenticationRequired: 511
    },
    FileFormat: { Pdf: 1, Xml: 2 }, //Định dạng file /// </summary> /// Công ty kế toán dịch vụ /// <summary> /// </summary> /// Cá nhân làm kế toán dịch vụ /// <summary>
    /*
     * Các kỳ liên quan đến khoảng thời gian phục vụ cho control DateRange
     */
    Period: {
        ThisDay: 20,
        ThisWeek: 30,
        FirstWeekToPresent: 31,
        ThisMonth: 45,
        Last30Days: 51,
        FirstMonthToPresent: 46,
        ThisQuarter: 60,
        FirstQuarterToPresent: 61,
        ThisYear: 500,
        FirstYearToPresent: 501,
        SixFirstMonth: 75,
        SixLastMonth: 70,
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        FiscalI: 100,
        FiscalII: 200,
        FiscalIII: 300,
        FiscalIV: 400,
        Yesterday: 21,
        LastWeek: 35,
        LastMonth: 50,
        LastQuarter: 65,
        LastYear: 80,
        Tomorrow: 25,
        NextWeek: 40,
        NextMonth: 55,
        NextQuarter: 66,
        NextYear: 90,
        Custom: 0,
        Last7Day: 81,
        Other: 1000
    }, //Qúy //Các tháng trong năm // ThreeLastYear: 85, //Qúy 1 // FourLastWeek: 41,

    /*
     * Các kỳ liên quan đến khoảng thời gian không vượt quá 30 ngày
     */
    PeriodMax30Days: {
        ThisDay: 20,
        ThisWeek: 30,
        FirstWeekToPresent: 31,
        ThisMonth: 45,
        Last30Days: 51,
        FirstMonthToPresent: 46,
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        Yesterday: 21,
        LastWeek: 35,
        LastMonth: 50,
        Custom: 0,
    },

    /*
     * Các kỳ liên quan đến khoảng thời gian phục vụ cho control DateRange
     */
    PastPeriod: {
        ThisDay: 20,
        ThisWeek: 30,
        FirstWeekToPresent: 31,
        ThisMonth: 45,
        Last30Days: 51,
        FirstMonthToPresent: 46,
        ThisQuarter: 60,
        FirstQuarterToPresent: 61,
        ThisYear: 500,
        FirstYearToPresent: 501,
        SixFirstMonth: 75,
        SixLastMonth: 70,
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        FiscalI: 100,
        FiscalII: 200,
        FiscalIII: 300,
        FiscalIV: 400,
        Yesterday: 21,
        LastWeek: 35,
        LastMonth: 50,
        LastQuarter: 65,
        LastYear: 80,
        Custom: 0
    },
    TimePeriodFilterConnect: {
        Last30Days: 51,
        ThisWeek: 30,
        ThisMonth: 45,
        ThisQuarter: 60,
        ThisYear: 500,
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        FiscalI: 100,
        FiscalII: 200,
        FiscalIII: 300,
        FiscalIV: 400,
        LastWeek: 35,
        LastMonth: 50,
        LastQuarter: 65,
        LastYear: 80,
        Custom: 0
    },
    PeriodNotToMore3Month: {
        ThisDay: 20,
        ThisWeek: 30,
        FirstWeekToPresent: 31,
        ThisMonth: 45,
        FirstMonthToPresent: 46,
        ThisQuarter: 60,
        FirstQuarterToPresent: 61,
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        FiscalI: 100,
        FiscalII: 200,
        FiscalIII: 300,
        FiscalIV: 400,
        Yesterday: 21,
        LastWeek: 35,
        LastMonth: 50,
        LastQuarter: 65,
        Custom: 0
    },
    SortStatus: { none: 0, desc: 1, asc: 2 },
    AuditingLogPeriod: {
        ThisDay: 20,
        ThisWeek: 30,
        ThisMonth: 45,
        ThisQuarter: 60,
        ThisYear: 500,
        Yesterday: 21,
        LastWeek: 35,
        LastMonth: 50,
        FiscalI: 100,
        FiscalII: 200,
        FiscalIII: 300,
        FiscalIV: 400,
        LastYear: 80,
        Custom: 0
    },
    SupplierPeriod: {
        //7 ngày gần nhất //Qúy 1 //Qúy 1 //Qúy //Các tháng trong năm /// Khoảng thời gian không quá 3 tháng khi xuất khẩu exel //Qúy 1 //Qúy //Khác //Các tháng trong năm
        Last7Day: 81,
        ThisMonth: 45,
        ThisQuarter: 60,
        ThisYear: 500
    },
    DashboardPeriod: {
        //7 ngày gần nhất //Tháng này //Quý này //năm nat
        Last7Day: 81,
        ThisMonth: 45,
        ThisQuarter: 60,
        ThisYear: 500,
        Other: 1000
    },
    SyncData: { ThisDay: 20, Yesterday: 21, Last7Day: 81, Last30Days: 51, Custom: 0 },
    CompareInv: {
        ThisWeek: 30,
        ThisMonth: 45,
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
        Custom: 0
    },
    ReconcileSessionResult: {
        Success: 0,
        MissingDate: 1,
        DateOrderInvalid: 2,
        BeforeMinimumDate: 3,
        ExceedsMaximumDateRange: 4,
        ToolBusy: 5,
        QuotaExceeded: 6,
        SessionCreationFailed: 7
    },
    GdtIndexing: {
        /// <summary> // 30 ngày gần nhất //Tháng này //Quý này //năm nat //Khoảng thời gian được chọn(giới hạn 1 năm) //7 ngày gần nhất
        /// Gặp lỗi trong quá trình chụp
        /// </summary>
        Error: -1,
        Pending: 0,
        Indexed: 1
    },
    /** /// </summary> /// Chưa thực hiện /// <summary> /// </summary> /// Đã tra cứu /// <summary>
     * Phương thức thanh toán
     */
    PaymentMethod: { ATM: 1, Visa: 2, PaymentProvider: 3, Tranfers: 4, Paypal: 5, Jetpay: 6 },
    CheckingResultEnum: {
        BuyerStatusAddress: 1,
        BuyerStatusName: 2,
        BuyerStatusTaxCode: 20,
        SellerStatusAddress: 3,
        SellerStatusName: 4,
        SellerSignature: 5,
        SellerStatus: 6,
        TaxRiskStatus: 7,
        ExistTCTStatus: 8,
        TaxaxionSignature: 9,
        UnitName: 10,
        Quantity: 11,
        UnitPrice: 12,
        ExchangeRate: 13,
        SyntheticVatRate: 14,
        CharacteristicGoods: 15,
        CheckLogic: 17,
        CompareAmountWordNumber: 18,
        InvoiceName: 19,
        BusinessLocation: 21,
    },
    InvoiceCheckingResult: { Buyer: 1, Seller: 2, Signature: 3, SellerActive: 4, TaxRisk: 5, ReleaseInv: 6 },
    TypeSendMail: { EmailTo: 1, Forward: 2, InvToSeller: 3, InvToMisa: 4 },
    FileType: { All: 0, Xml: 1, Pdf: 2, Image: 3, PdfAndXml: 5 },
    InvoiceTemplate: { TaxRate: 1, ManyTaxRate: 2 },
    VatRate: { Rate10: 10, Rate8: 8, Rate5: 5, Rate0: 0, KCT: -1, KKKNT: -2, KHAC: -3, KTPVDC: -5, KTGTT: -6 },
    KindChange: { None: 0, BuyerStatusAddress: 1, BuyerStatusName: 2, SellerStatusAddress: 3, SellerStatusName: 4 },
    /** /// </summary> /// Đơn vị tính //ATM //thẻ visa, master card //Ví điện tử //Chuyển khoản, /// <summary> /// </summary> /// Số lượng /// <summary> /// </summary> /// Đơn giá /// <summary> /// </summary> /// Tỷ giá /// <summary> /// </summary> /// Tổng hợp Thuế suất /// <summary> /// </summary> /// Hàng hóa đặc trưng /// <summary> // Tính toán số liệu
     * Nguồn gốc tạo ra hóa đơn. Tự động đọc hay nhập tay, lưu nháp
     */
    InvoiceCreatorFlags: { NotInvoice: 0, AutoRead: 1, Handing: 2, Draft: 3, ValidNotInfo: 4, AutoReadTool: 5 },
    /** //KP hóa đơn //hóa đơn tự đọc bởi hệ thống //Hóa đơn nhập tay //Lưu nháp // Hóa đơn không đủ thông tin để kiểm tra nhưng vẫn hợp lệ
     * Lỗi khi xử lý hóa đơn nhập tay
     */
    ResultHanding: { Success: 0, Exist: 1, Expired: 2, OutOfQuantity: 3, ExistConfirmPdf: 4, ExistWarnningPdf: 5 },
    /** //Trạng thái thành công //Hóa đơn đã tồn tại //Hết thời hạn sử dụng hóa đơn //Hết số lượng hóa đơn được sử dụng //Đã tồn tại hóa đơn nhưng chưa có file PDF confirm lại để gán pdf //Đã tồn tại hóa đơn không có quyền ở chi nhánh đó nên cảnh báo
     * Flags hiển thị danh sách hóa đơn từ hộp thư
     */
    FlagShowInvoices: {
        All: 0,
        Valid: 1,
        Invalid: 2,
        Duplicated: 3,
        NoRead: 4,
        Expired: 5,
        OutOfQuantity: 6,
        NotNeedCheck: 31
    },
    /** //Tất cả //Hóa đơn hợp lệ //Hóa đơn không hợp lệ //Hóa đơn trùng //File không đọc được //Hóa đơn hết hạn sử dụng //Hóa đơn hết số lượng sử dụng
     * Sử dụng form dùng thử hóa đơn từ
     */
    CallFrom: { MeInvoice: 1, SME: 2, MAKT: 3, ASP: 4, EShop: 5 },
    InvoiceCustomTemplate: {
        /// <summary> //Đi từ sản phẩm meinvocie //Đi từ sản phẩm SME //Đi từ sản phẩm MAKT // Đi từ sản phẩm ASP
        /// Mẫu bình thường
        /// </summary>
        None: 0,
        InvoiceSeaFee: 1,
        InvoiceWaterBĐ: 2,
        FinancialLeasing: 3,
        AgentWarehouseExport: 4,
        InternalWarehouseExport: 5,
        InvoiceSales: 6,
        Invoice123: 7, /// Biên lai NĐ 70 /// </summary> /// </summary> /// Mẫu biên lai, lệ phí hàng hải /// <summary> /// Mẫu hóa đơn nước Bình Định /// <summary> /// </summary> /// Mẫu hóa đơn cho thuê tài chính CHAILEASE /// <summary> /// </summary> /// Mẫu hóa đơn 123 PHiếu xuất kho hàng gửi đại lý /// <summary> /// </summary> /// Mẫu hóa đơn 123 Phiếu xuất kho kiêm vận chuyển nội bộ /// <summary> /// </summary> /// Mẫu hóa đơn 123 Hóa đơn bán hàng /// <summary> /// </summary> /// Mẫu hóa đơn 123 hóa đơn GTGT /// <summary> /// <summary>
        /// </summary>
        Receipt70: 8,
        InvoiceCommercial: 9
    },
    AuditingLogActionType: {
        /// Chưa xác định
        None: 0,
        Upload: 1,
        DeleteInvoice: 2,
        RestoreInvoice: 3,
        InvoiceAccept: 4,
        UpdateSupplierCode: 5,
        InvoiceStick: 6,
        InvoiceAttachFile: 7,
        InvoiceDescription: 8,
        UpdateCompany: 9,
        DeleteEmail: 10,
        RestoreEmail: 11,
        DeleteForeverEmail: 12,
        InvoiceAttachFileRemove: 13,
        AddCompany: 14,
        DeleteCompany: 15,
        DeleteInvoiceStick: 16,
        Accounted: 17,
        UnAccounted: 18,
        ReUploadInvoicePdf: 19,
        ReUploadInvoiceImg: 20,
        UpdateRoleUser: 21,
        MoveInvoice: 22,
        AcceptSellerSignature: 23,
        AcceptSellerActiveStatus: 24,
        AcceptTaxRiskStatus: 25,
        ConnectInvoiceLogin: 26,
        ConnectInvoiceLogout: 27,
        EditHandEntered: 28,
        ConnectTaxaxionLogin: 29,
        ConnectTaxaxionLogout: 30,
        ConnectInvoiceSync: 31,
        ConnectTaxaxionSync: 32,
        CheckingVat: 33,
        CheckAgainEmail: 34,
        RefreshInvoiceTaxaxion: 35,
        SettingSystemDownload: 36,
        SettingSystemPayment: 37,
        AcceptPayment: 38,
        InvoiceSticks: 39,
        RemoveStick: 40,
        RemoveAndAttachStick: 41,
        InsertDeleteStick: 42,
        UpdateStick: 43,
        HandEntered: 44,
        SaveDraft: 45,
        AddUser: 46,
        DeleteUser: 47,
        AddJobTitle: 48,
        AddRolePermission: 49,
        DeleteRolePermission: 50,
        EditRolePermission: 51,
        DeleteOutInvoice: 52,
        RestoreOutInvoice: 53,
        MoveOutInvoice: 54,
        ConnectDownloadMeInvoice: 55,
        ConnectAgainTaxaxion: 56,
        UnConnectTaxaxion: 57,
        ConnectTaxaxionInvoice: 58,
        UnConnectDownloadMeInvoice: 59,
        AcceptExistTCT: 60,
        CheckAgianV2: 61,
        UnRead: 62,
        RemoveSticks: 63,
        AttachStick: 64,
        SettingTransformOrg: 65,
        InsertTransformOrg: 66,
        EditTransformOrg: 67,
        DeleteTransformOrg: 68,
        InsertSupplier: 69,
        CheckAgainMultiEmail: 70,
        InsertSupNoDownInv: 71,
        DeleteSupNoDownInv: 72,
        UnSettingTransformOrg: 73,
        SettingNoDownloadInvoice: 74,
        AcceptTaxaxionSignature: 75,
        RefreshInvoice: 76,
        UploadOutInvoice: 77,
        SettingTransferInvByTaxCode: 78,
        UnSettingTransferInvByTaxCode: 79,
        AddTransferInvByTaxCode: 80,
        UpdateTransferInvByTaxCode: 81,
        DeleteTransferInvByTaxCode: 82,
        DownloadInvoiceWithoutCode: 83,
        DownloadOutInvoiceWithoutCode: 84,
        UnDownloadInvoiceWithoutCode: 85,
        UnDownloadOutInvoiceWithoutCode: 86,
        ConnectAgainSupplier: 87,
        UploadFileXML: 88,
        SelectOtherDownloadInvoiceInbot: 89,
        UnSelectOtherDownloadInvoiceInbot: 90,
        SelectOtherDownloadInvoiceOutInbot: 91,
        UnSelectOtherDownloadInvoiceOutInbot: 92,
        SettingTypeDownloadInvoiceInbot: 93,
        SettingTypeDownloadInvoiceOutbot: 94,
        AcceptCheckTax: 95,
        UnPaymentInvoice: 96,
        SettingSystemIgnoreExistTax: 97,
        ActionSupplierAcceptTaxAuthority: 98,
        ActionEmailReceiveAlert: 99,
        SettingActionEmailReceiveAlert: 100,
        RemovePdf: 101,
        SettingRemind: 102,
        TaxaxionSyncByTool: 103,
        UpdatePdfInvoice: 104,
        UpdatePdfFromEmail: 105,
        UpdatePdfFromSearch: 106,
        AutoDownloadPdf: 107,
        SettingTemplate: 108,
        UploadFilePdf: 109,
        UploadDeclaration: 110,
        AcceptedUnitName: 111,
        AcceptedQuantity: 112,
        AcceptedUnitPrice: 113,
        DeleteItemVatRate: 114,
        EditHistoryVatRate: 115,
        SpamEmail: 116,
        NotSpamEmail: 117,
        UserSetup: 118,
        ClassificationCost: 119,
        ClassificationCostMany: 120,
        SettingClassificationInvoice: 121,
        AcceptExchangeRate: 122,
        SyntheticVatRate: 123, /// </summary> /// <summary> /// </summary> /// Kiểm tra thuế suất NQ43 /// Upload hóa đơn /// Xóa hóa đơn /// Khôi phục hóa đơn /// Chấp nhận tên địa chỉ hóa dơn /// Cập nhật mã NCC /// Dán nhãn /// Đính kèm tệp vào hóa đơn /// Ghi chú trên hóa đơn /// Chi nhánh phòng ban /// Xóa /// Khôi phục email /// Xóa vĩnh viễn /// Xóa file đính kèm /// Thêm chi nhánh phòng ban /// Xóa chi nhánh phòng ban /// Xóa dán nhãn /// Đã hạch toán /// Chưa hạch toán /// Upload lại hóa đơn pdf /// Upload lại ảnh /// Phân quyền //Điều chuyển hóa đơn /// Chấp nhận chữ ký số hợp lệ /// Chấp nhận hoạt động người bán hợp lệ /// Chấp nhận rủi ro người bán hợp lệ /// Đăng nhập kết nối HĐ /// Hủy kết nối HĐ /// Sửa HĐ nhập tay ///Đăng nhập kết nối dữ liệu CQT ///Hủy kết nối dữ liệu CQT ///Đồng bộ dữ liệu ncc ///Đồng bộ dữ liệu cơ quan thuế /// <summary> /// </summary> /// Kiểm tra lại email /// <summary> /// </summary> /// Tải lại hóa đơn của cqt /// <summary> /// </summary> /// Thiệt lập tên file tải xuống /// <summary> /// </summary> /// Thiệt lập nhắc hạn thanh toán /// <summary> /// </summary> /// Đánh dấu thanh toán /// <summary> /// </summary> /// Gắn nhãn hàng loạt cho nhiều hóa đơn /// <summary> /// </summary> /// Bỏ nhãn dán /// <summary> /// </summary> /// Bỏ và gắn nhãn dán /// <summary> /// </summary> /// Thêm/xóa nhãn dán /// <summary> /// </summary> /// Sửa nhãn dán /// <summary> /// </summary> /// Lưu và kiểm tra hóa đơn nhập tay /// <summary> /// </summary> /// Lưu nháp hóa đơn nhập tay /// <summary> /// </summary> /// Thêm người dùng /// <summary> /// </summary> /// Xóa người dùng /// <summary> /// </summary> /// Thêm mới chức danh /// <summary> /// </summary> /// Thêm mới vai trò quyền hạn /// <summary> /// </summary> /// Xóa vai trò quyền hạn /// <summary> /// </summary> /// Sửa vai trò quyền hạn /// <summary> /// </summary> /// Xóa hóa đơn đầu ra /// <summary> /// </summary> /// Khôi phục hóa đơn đầu ra /// <summary> /// </summary> /// Điều chuyển hóa đơn đầu ra /// <summary> /// </summary> /// Thiết lập tải hóa đơn Đầu ra MeInvoice trên CQT /// <summary> /// </summary> /// Kết nối lại CQT /// <summary> /// </summary> /// Kết nối tài khoỏa /// <summary> /// </summary> ///Bỏ Thiết lập tải hóa đơn Đầu ra MeInvoice trên CQT /// <summary> /// </summary> /// Chấp nhận tồn tại trên hệ thống cơ quan thuế /// <summary> /// </summary> /// Kiểm tra lại hóa đơn đang kiểm tra /// <summary> /// </summary> /// Đánh dấu email chưa đọc /// <summary> /// </summary> ///Bỏ nhãn hàng loạt cho các hóa đơn chọn /// <summary> /// </summary> /// Thiệt lập nhắc hạn thanh toán //Gắn nhãn /// <summary> /// </summary> /// Thêm chi nhánh thiết lập tự động điều chuyển hđ /// <summary> /// </summary> /// Sửa chi nhánh thiết lập tự động điều chuyển hđ /// <summary> /// </summary> /// Xóa chi nhánh thiết lập tự động điều chuyển hđ /// <summary> /// </summary> /// Thêm mới NCC /// <summary> /// </summary> /// Kiểm tra lại hàng loạt email /// <summary> /// </summary> /// Thêm NCC không tải về hóa đơn /// <summary> /// </summary> /// Xóa NCC không tải về hóa đơn /// <summary> /// </summary> /// Bỏ thiết lập tự động điều chuyển /// <summary> /// </summary> /// Thiết lập không tự động tải hóa đơn từ một số NCC /// <summary> /// </summary> //Bỏ thiết lập điều chuyển hóa đơn từ nguồn email /// Chấp nhận chữ ký số CQT hợp lệ /// Tải lại hóa đơn NCC /// Upload hóa đơn đầu ra //Thiết lập điều chuyển hóa đơn từ nguồn email /// <summary> /// </summary> /// Thêm thiết lập điều chuyển hóa đơn từ nguồn email /// <summary> /// </summary> /// Cập nhật định mức hóa đơn /// </summary> /// Sửa thiết lập điều chuyển hóa đơn từ nguồn email /// <summary> /// </summary> /// Xóa thiết lập điều chuyển hóa đơn từ nguồn email /// <summary> /// </summary> /// Tải hóa đơn đầu vào không mã theo hình thức BTH /// <summary> /// </summary> /// Tải hóa đơn đầu ra không mã theo hình thức BTH /// <summary> /// </summary> /// Bỏ thiết lập Tải hóa đơn đầu vào không mã theo hình thức BTH /// <summary> /// </summary> ///Bỏ thiết lập Tải hóa đơn đầu ra không mã theo hình thức BTH /// <summary> /// </summary> /// Kết nối lại Nhà cung cấp /// <summary> /// </summary> /// Tải lại file(Xml) /// <summary> /// </summary> /// Thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu vào /// <summary> /// </summary> ///  Bỏ thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu vào /// <summary> /// </summary> /// Thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu ra /// <summary> /// </summary> /// Bỏ thiết lập  chọn loại hóa đơn tải về khác từ CQT đầu ra /// <summary> /// </summary> /// Thiết lập loại hóa đơn đầu ra tải về từ nguồn CQT /// <summary> /// </summary> /// Thiết lập loại hóa đơn đầu vào tải về từ nguồn CQT /// <summary> /// </summary> /// Chấp nhận kiểm tra thuế suất /// <summary> /// </summary> /// Bỏ đánh dấu thanh toán hóa đơn /// <summary> /// </summary> ///Thiết lập không kiểm tra tồn tại CQT /// <summary> /// </summary> /// </summary> /// Thêm/sửa/xóa với các mẫu NCC trong thiết không kiểm tra tồn  tại CQT /// <summary> /// Cảnh báo email /// <summary> /// </summary> /// Chấp nhận đơn vị tính // Thiết lập mẫu hóa đơn mặc định //Tờ khai hải quan /// <summary> /// </summary> /// Chấp nhận số lượng /// <summary> /// </summary> /// Chấp nhận đơn giá /// <summary> /// </summary> /// Xóa thông tin HHDV trong lịch sử chấp nhận thuế suất /// <summary> /// </summary> /// Sửa thông tin lịch sử chấp nhận thuế suất /// <summary> /// </summary> /// Email spam /// <summary> /// </summary> /// không phải Email spam /// <summary> /// </summary> /// Phân loại chi phí hóa đơn // Thiết lập người dùng /// <summary> /// </summary> /// Phân loại chi phí hàng loạt hóa đơn /// <summary> /// </summary> /// Chấp nhận tỷ giá ///Thiết lập tự động phân loại hóa đơn /// <summary> /// </summary> /// Chấp nhận thuế suất tổng hợp /// <summary> /// <summary>
        SettingCostType: 124, /// </summary> /// Cập nhật định mức chi phí cho 1 hóa đơn /// <summary>
        UpdateInvoiceCostType: 125, /// </summary> /// Cập nhật định mức chi phí cho nhiều hóa đơn /// <summary>
        UpdateInvoiceCostTypeMany: 126, /// </summary> /// Xóa tờ khai /// <summary>
        DeleteDeclaration: 127, /// </summary> /// Khôi phục tờ khai /// <summary>
        RestoreDeclaration: 128, /// </summary> /// Điều chuyển tờ khai /// <summary>
        MoveOnDeclaration: 129, /// </summary> /// Kiểm tra lại tờ khai /// <summary>
        DeclarationCheckAgain: 130, /// </summary> /// Khôi phục hàng loạt /// <summary>
        RestoreInvoices: 131, /// </summary> /// Khôi phục hàng loạt hóa đơn đầu ra /// <summary>
        RestoreOutInvoices: 132, /// </summary> ///Thiết lập định mức chi phí /// <summary>
        SettingCostNorms: 133,
        AcceptMultiResult: 134, /// </summary> /// Sửa đổi email nhận hóa đơn /// <summary>
        UpdateInvoiceEmailReceive: 135, /// <summary>
        /// Cập nhật thông tin theo user
        /// </summary>
        UpdateFilterInvoiceList: 136,
        SettingSystemCriteriaVerification: 138,
        SaveCriteriaSetup: 139, /// Hàng hóa đặc trưng ///Lưu thiêt lập tiêu chí kiểm tra cài đặt ///Lưu thiêt lập tiêu chí kiểm tra cài đặt trong popup /// <summary>
        /// </summary>
        CharacteristicGoods: 140,
        SettingAbbreviationSetup: 141,
        SaveAbbreviationSetup: 142,
        ChangeIdentificationNumberOrganizationChange: 144, /// Chấp nhận kiểm tra logic /// <summary>
        /// </summary>
        AcceptCheckLogic: 145,
        CompareTotalAmountInWordsAndNumbers: 146,
        AutoDownloadXml: 147,
        DeleteSupOnlyDownInv: 148,
        InsertSupOnlyDownInv: 149,
        AcceptInvoiceName: 150,
        ChooseSupplierOnlyOrSupplierNoDownloadInv: 151,
        /// <summary>
        /// Bỏ chấp nhận tên địa chỉ hóa dơn
        /// </summary>
        InvoiceUnAccept: 152,
        /// <summary>
        /// Bỏ Chấp nhận hợp lệ tên hóa đơn
        /// </summary>
        UnacceptInvoiceName: 153,
        SettingAmountBeforeDiscountSetup: 155,
        AcceptBusinessLocation: 156,
        DeleteDeclarationBatch: 157, // Xóa hàng loạt tờ khai hải quan
        CheckAgainOutInvoice: 158, //Kiểm tra hóa đơn đầu ra
        SettingShowInvoiceLoadingList: 159, //Thay đổi thiết lập hiển thị danh sách hóa đơn đang tải
        ReloadPendingInvoice: 160, //Tải lại dòng hóa đơn đầu vào đang tải
        ReloadPendingOutInvoice: 161, //Tải lại dòng hóa đơn đầu ra đang tải
    },
    OrganizationType: { Company: 1, Household: 2 },
    InvType: { Both: 0, Invoice: 1, OutInvoice: 2 },
    AttachStatus: { All: 0, HasAttachFile: 1, NotHasAttachFile: 2 },
    LicenseStatus: { Official: 1, Trial: 2 },
    ErrorFeedback: {
        /// <summary> //Thuê bao chính thức //Thuê bao dùng thử /// <summary> /// Công ty /// <summary> /// <summary> /// Hộ kinh doanh /// <summary>
        /// Lỗi thông tin người mua
        /// </summary>
        Buyer: 1,
        Seller: 2,
        Signature: 3,
        SellerActive: 4,
        TaxRisk: 5,
        PublishedInvoice: 6,
        Other: 7
    },
    PaymentStatus: {
        // Trạng thái thanh toán: /// </summary> /// Lỗi thông tin người bán /// <summary> /// </summary> /// Lỗi chữ kí số /// <summary> /// </summary> /// Lỗi tình trạng hoạt động của người bán /// <summary> /// </summary> /// Lỗi Tình trạng rủi ro về thuế /// <summary> /// </summary> /// Thông báo phát hành hóa đơn /// <summary> /// </summary> /// Khác /// <summary>
        /// Chưa thanh toán
        New: 0,
        WaitPaymentConfirm: 1,
        SentPaymentConfirm: 2,
        Paid: 3,
        CancelPayment: 4
    },
    DateFilterType: {
        /// <summary> /// Chờ xác nhận thanh toán /// Đã gửi xác nhận thanh toán /// Đã thanh toán /// Đã hủy
        /// Ngày hóa đơn
        /// </summary>
        InvoiceDate: 1,
        AccountingDate: 2,
        ReceivedDate: 3,
        PaymentWarning: 4,
        PaymentOutOfDate: 5,
        PaymentNotPay: 6,
        ChangeStatusInvoiceDate: 7,
        ChangeStatusInvoiceOnSystemDate: 8
    },
    StatusLicenseWarning: {
        /// <summary> /// </summary> /// Ngày hạch toán /// <summary> /// </summary> /// Ngày nhận hóa đơn /// <summary> /// </summary> /// Ngày đến hạn thanh toán /// <summary> /// </summary> /// Ngày quá hạn thanh toán /// <summary> /// </summary> /// Ngày chưa thanh toán /// <summary> /// </summary> /// Ngày thay đổi trạng thái hóa đơn trên CQT /// <summary> /// </summary> /// Ngày thay đổi trạng thái hóa đơn trên PM Inbot /// <summary>
        /// Bình thường
        /// </summary>
        Normal: 0,
        ExpiredComingdDate: 1,
        ExpiredDate: 2,
        ExpiredCommingInvoice: 3,
        ExpiredInvoice: 4,
        ExpiredCommingInvoiceDate: 5,
        ExpiredInvoiceDate: 6
    },
    TypeOrganization: {
        /// <summary> /// </summary> /// Gói tài nguyên sắp hết thời hạn /// <summary> /// </summary> /// Gói tài Nguyên hết hạn /// <summary> /// </summary> /// Gói tài nguyên sắp hết số hóa đơn /// <summary> /// </summary> /// Gói tài nguyên hết số hóa đơn /// <summary> /// </summary> /// Gói tài nguyên sắp hết thời hạn  và săp hết số hóa đơn /// <summary> /// </summary> /// Gói tài nguyên hết thời hạn và hết số lượng hóa đơn /// <summary>
        /// Công ty
        /// </summary>
        Company: 1,
        Branch: 2,
        Department: 3
    },
    KindAccountingDate: { All: 0, Accounted: 1, NotAccounted: 2 },
    StatusView: { All: 0, Viewed: 1, UnViewed: 2 },
    InvoiceEmailStatus: {
        All: 100,
        InvoiceValid: 2,
        EmailInvalid: 99,
        MaxAttachmentSize: 64,
        InvoiceInvalid: 3,
        InvoiceDuplicate: 10,
        InvoiceNoRead: 98,
        Draft: 97,
        Checking: 96,
        Expired: 11,
        InvoiceDetele: 95,
        InvoiceNotNeedCheck: 31
    },
    ConnectInvoiceEnum: {
        MeInvoice: 1,
        Grab: 2,
        HonDa: 3,
        CocaCola: 4,
        Taxaxion: 5,
        Lavie: 6,
        TrungKien: 7,
        EPass: 8,
        BIDV: 9,
        EVN: 10,
        VNPT: 11,
        Nawasco: 12,
        Petrolimex: 13,
        ThuPhiHP: 14,
        MSB: 15,
        VETC: 16,
        AEON: 17,
        PhuYen: 18,
        Viettel: 19,
        VNPost: 20,
        SamSung: 21
    },
    TypeInvoiceReceive: {
        /// <summary> /// </summary> /// Chi nhánh /// <summary> /// </summary> /// Phòng ban /// <summary>
        /// Tất cả
        /// </summary>
        All: 0,
        Upload: 1,
        Email: 2,
        Auto: 3,
        HandInput: 4
    },
    ConnectInvoiceStatus: {
        /// <summary> /// </summary> /// Hóa đơn upload /// <summary> /// ///Hóa đơn email /// /// </summary> /// Tự động tải về /// <summary> /// </summary> /// Chỉ để phục vụ cho trường hợp lọc ra hóa đơn nhập tay /// <summary>
        /// Chưa xử lý
        /// </summary>
        New: 0,
        Processing: 1,
        Success: 2,
        Fail: 3,
        Duplicated: 4,
        Ignore: 5,
        All: 6
    },
    /** /// </summary> /// Đang xử lý /// <summary> /// </summary> /// Xử lý thành công /// <summary> /// </summary> /// Xử lý thất bại /// <summary> /// </summary> /// Hóa đơn trùng /// <summary> /// </summary> /// Trạng thái hóa đơn của misa và không tải về /// <summary> /// </summary> /// Lấy tất cả hóa đơn dùng cho trường hợp xuất khẩu /// <summary>
     * Flags hiển thị danh sách hóa đơn tự động tải
     */
    FlagInvoicesAuto: {
        All: 0,
        DownSuccess: 1,
        DownFail: 2,
        InvoiceSuccess: 3,
        InvoiceFail: 4,
        InvoiceDuplicate: 5,
        InvoiceIgnore: 6,
        InvoiceProcessing: 7
    },
    BookmarkEmail: { None: 0, TagStar: 1 },
    KindND123Enum: {
        /// <summary> //Tất cả //Hóa đơn tải thành công //Hóa đơn tải thất bại //Hóa đơn đã xử lý //Hóa đơn không đọc được //Hóa đơn trùng //Trạng thái hóa đơn của misa và không tải về //Hóa đơn đang xử lý, chưa có kết quả
        /// Tính chất 1 là HDDV
        /// </summary>
        Info: 1,
        Promotion: 2,
        Discount: 3,
        Noted: 4,
        SpecificProduct: 5
    },
    SpecificProductType: {
        /// <summary> /// </summary> /// Tính chất 2 là khuyến mãi /// <summary> /// </summary> /// Tính chất 3: CKTM trong trường hợp muốn thể hiện thông tin CK theo dòng /// <summary> /// </summary> /// Tính chất 4: Ghi chú diễn giải /// <summary> /// </summary> /// Tính chất 5: Hàng hóa đặc biệt /// <summary>
        /// Chưa xác định
        /// </summary>
        Unknown: 0, /// <summary>
        /// Kinh doanh xe máy, ô tô
        /// </summary>
        /// <remarks>
        /// - Áp dụng cho hóa đơn bán xe máy, xe ô tô
        /// - Cần có thông tin về số khung (SKhung) và số máy (SMay)
        /// </remarks>
        VehicleSelling: 1, /// <summary>
        /// Dịch vụ vận chuyển
        /// </summary>
        /// <remarks>
        /// - Áp dụng cho hóa đơn dịch vụ vận chuyển truyền thống
        /// - Cần có thông tin biển kiểm soát phương tiện vận chuyển (BKSPTVChuyen)
        /// </remarks>
        TransportService: 2, /// <summary>
        /// Dịch vụ vận chuyển trên nền tảng số, TMĐT
        /// </summary>
        /// <remarks>
        /// - Áp dụng cho hóa đơn dịch vụ vận chuyển của các nền tảng số, TMĐT
        /// - Cần có thông tin người gửi hàng và các thông tin định danh liên quan
        /// </remarks>
        DigitalTransport: 3,
        /// Kinh doanh, chuyển nhượng bất động sản (nhà đất) - NĐ254
        RealEstate: 4
    },
    /// Loại tài sản xe (NĐ254, thẻ LTSan)
    VehicleAssetTypeEnum: { Car: 1, Motorcycle: 2 },
    /// Tình trạng tài sản xe (NĐ254, thẻ TTTSan)
    VehicleAssetStatusEnum: { Unused: 0, Used: 1 },
    /// Xuất xứ xe (NĐ254, thẻ XXu)
    VehicleOriginEnum: { Domestic: 0, Imported: 1 },
    TinhChatEnum: { Goc: 1, ThayThe: 2, DieuChinh: 3, ChietKhauThuongMai: 4 },
    TThaiHDonEnum: { Goc: 1, ThayThe: 2, DieuChinh: 3, DaThayThe: 4, DaDieuChinh: 5, Xoa: 6, Unknown: 7 },
    PrintType: {
        /// <summary> // Hóa đơn gốc // Hóa đơn thay thế // Hóa đơn điều chỉnh // Hóa đơn bị thay thế // Hóa đơn bị điều chỉnh // Hóa đơn đã bị xóa bỏ/hủy bỏ // Hóa đơn chưa xác định //Hóa đơn gốc //Hóa đơn thay thế //Hóa đơn điều chỉnh
        /// In kết quả kiểm tra
        /// </summary>
        CheckingResult: 1,
        Template: 2,
        CheckingResultAdvanded: 3
    },
    TypeWarning: { Popup: 1, Banner: 2 },
    ReasonType: {
        /// <summary> /// </summary> /// In mẫu hóa đơn /// <summary> /// </summary> /// In kết quả kiểm tra nâng cao /// <summary>
        /// Sản phẩm không đáp ứng nhu cầu
        /// </summary>
        ProductNotGood: 1,
        ProductError: 2,
        SupportServiceNotGood: 3,
        HighPrice: 4,
        UseConvenient: 5,
        SlowProcessingSpeed: 6,
        SecurityNotGood: 7,
        ReasonOther: 0
    },
    /** /// </summary> /// Sản phẩm hay bị lỗi /// <summary> /// </summary> /// Dịch vụ tư vấn hỗ trợ khách hàng kém /// <summary> /// </summary> /// Giá thành cao /// <summary> /// </summary> /// Thao tác sử dụng không thuận tiện /// <summary> /// </summary> /// Tốc độ xử lý chậm /// <summary> /// </summary> /// Bảo mật phần mềm kém /// <summary> /// </summary> /// Lý do khác /// <summary>
     * Enum đánh dấu kiểu mất kết nối từ CQT ví dụ như thay đổi mật khẩu, hết tài nguyên ...
     */
    ReasonTypeFlags: {
        /// <summary>
        /// Không làm gì
        /// </summary>
        None: 0, /// </summary>
        /// Hết tài nguyên
        /// <summary>
        LicenseExpired: 1, /// </summary>
        /// Tài khoản bị Thay đổi mật khẩu/Khóa/Vô hiệu hóa
        /// <summary>
        ChangeOrLockAccount: 2, /// </summary>
        /// Mất kết nối
        /// <summary>
        LostConnection: 3, /// </summary>
        /// Không có quyền Tra cứu hóa đơn
        /// <summary>
        NotPermissionLookupInvoice: 4, /// <summary>
        /// Ngắt kết nối
        /// </summary>
        Disconnection: 5, /// <summary>
        /// Bỏ qua
        /// </summary>
        Ignore: 6, /// <summary>
        /// Mã số thuế người mua/Bán không khớp với yêu cầu
        /// </summary>
        NotMapTaxCode: 7, /// <summary>
        /// Lấy chi tiết hóa đơn thất bại
        /// </summary>
        GetDetailFail: 8, /// <summary>
        /// Xảy ra lỗi ngoại lệ
        /// </summary>
        Exception: 9, /// <summary>
        /// Không có mã tra cứu
        /// </summary>
        EmptyCode: 10, /// <summary>
        /// Tải file thất bại
        /// </summary>
        DownloadFileFail: 11, /// <summary>
        /// Không tìm thấy thông tin hóa đơn
        /// </summary>
        InvoiceNotFound: 12, /// <summary>
        /// Không có link tải hóa đơn
        /// </summary>
        DownloadUrlNull: 13, /// <summary>
        /// Đăng nhập ở máy khác
        /// </summary>
        LoginInDeviceAnother: 14, /// <summary>
        /// Chuyển đổi chuỗi json hóa đơn của thuế về InvoiceInfo thất bại
        /// </summary>
        MapDataInvoiceFail: 15, /// <summary>
        /// Tạo Connect Invoice Master thất bại
        /// </summary>
        CreateInvoiceMasterFail: 16, /// <summary>
        /// Hóa đơn trùng (Hóa đơn đã tồn tại trong hệ thống)
        /// </summary>
        InvoiceDuplicated: 17, /// <summary>
        /// Tạo Connect Invoice Detail thất bại
        /// </summary>
        CreateInvoiceDetailFail: 18
    },
    CheckingVatStatusFlags: { None: 0, Exact: 1, UnExact: 2, Checking: 3, ErrorCheckingVat: 24, Accept: 5 },
    ReductionStatus: {
        /// <summary> // Mặc định // Thuế suất chính xác // Thuế suất chưa chính xác //Đang kiểm tra lại hóa đơn // Lỗi thuế suất giảm giá //Thuế suất đã được chấp nhận //Enum thể hiện trạng thái kiểm tra thuế suất
        /// Không giảm thuế
        /// </summary>
        NoReduction: 0,
        Reduction: 1,
        None: 2
    },
    AmountPayment: {
        /// <summary> /// </summary> /// Có giảm thuế /// <summary> /// </summary> /// Chưa kiểm tra /// <summary>
        /// Không thiết lập
        /// </summary>
        Nothing: 0,
        NotPair: 1,
        PairAll: 2,
        PairOutOfDate: 3,
        PairWarning: 4,
        PairPart: 5
    },
    StickStatus: {
        /// <summary> /// </summary> /// Chưa thanh toán /// <summary> /// </summary> /// Thanh toán toàn phần /// <summary> /// </summary> /// Quá hạn thanh toán /// <summary> /// </summary> /// Đến hạn thanh toán /// <summary> /// </summary> /// Thanh toán một phần /// <summary>
        ///
        /// </summary>
        None: 0,
        Add: 1,
        Delete: 2,
        Update: 3
    },
    TypeStick: { StickOne: 1, StickMany: 2 },
    TThaiXuLyEnum: {
        ThueNhan: 0,
        DangKiemtra: 1,
        ThueTuChoi: 2,
        DuDKien: 3,
        KhongDuDKien: 4,
        DaCapMa: 5,
        NhanKhongCapMa: 6,
        DaKiemTraKhongCoMa: 7,
        NhanHDMayTinhTien: 8
    },
    WorkPermissionEnum: {
        InvoiceDeleteAndRestore: 1,
        InvoiceAccounting: 2,
        InvoiceTransfer: 3,
        InvoicePayment: 4,
        EmailDeleteAndRestore: 5,
        OrganizationAdd: 6,
        OrganizationEdit: 7,
        OrganizationDelete: 8,
        AcceptSellerBuyer: 9,
        AcceptSignature: 10,
        AcceptActiveRisk: 11,
        OutInvoiceDeleteAndRestore: 12,
        OutInvoiceTransfer: 13,
        ConnectTaxaxion: 14,
        ConnectSupplier: 15,
        IgnoreCheckExistTax: 16,
        HandInput: 17,
        AcceptVatRate: 18,
        AcceptOther: 19,
        ConnectTaxaxionInput: 20,
        ConnectTaxaxionOutput: 21,
        InvoiceAdd: 22,
        InvoiceSync: 23,
        OutInvoiceAdd: 24,
        OutInvoiceSync: 25
    },
    InvoiceActionType: {
        //Chuyển hóa đơn đầu vào giữa các phòng ban //Tổng cục Thuế đã nhận // Đang tiến hành kiểm tra điều kiện cấp mã // CQT từ chối hóa đơn theo từng lần phát sinh // Hóa đơn đủ điều kiện cấp mã // Hóa đơn không đủ điều kiện cấp mã // Đã cấp mã hóa đơn // Tổng cục thuế đã nhận không mã //Đã kiểm tra định kỳ HĐĐT không có mã //Đã tiếp nhận hóa đơn máy tính tiền //Xóa và khôi phục hóa đơn //Đánh dấu hạch toán //Điều chuyển //Đánh dấu thanh toán //Đánh dấu spam, Xóa và khôi phục thư //Thêm cơ cấu tổ chức //Sửa cơ cấu tổ chức //Xóa cơ cấu tổ chức //Chấp nhận thông tin người bán, người mua //Chấp nhận thông tin chữ ký số //Chấp nhận tình trạng hoạt động + tình trạng rủi ro của người bán //Xóa và khôi phục hóa đơn đầu ra //Điều chuyển  hóa đơn đầu ra //Tự động kết nối CQT //Tự động kết nối NCC //Bỏ qua kiểm tra tồn tại hóa đơn (theo mẫu NCC đã thiết lập), //Nhập tay hóa đơn //Chấp nhận thuế suất hàng hóa //Chấp nhận thông tin khác /// </summary> /// Thêm nhãn /// <summary> /// </summary> /// Xóa nhãn /// <summary>
        MOVE: 1,
        MOVE_OUT: 2,
        MOVE_DECLARATION: 3
    },
    ReadEmailStatus: {
        /// <summary> //Chuyển hóa đơn đầu ra giữa các phòng ban //Điều chuyển tờ kahi giiữa các phòng ban
        /// Tất cả
        /// </summary>
        All: 0,
        NotRead: 1,
        Read: 2
    },
    InvoiceCodeStatus: { None: 1, WithCode: 2, WithoutCode: 3 },
    FoundFileSrcFlags: {
        /// <summary> /// </summary> /// Mail chưa đọc /// <summary> /// </summary> /// Mail đã đọc /// <summary> /// </summary> /// Hóa đơn có mã /// <summary> /// </summary> /// Hóa đơn không mã /// <summary>
        /// Không có file
        /// </summary>
        None: 0,
        FromAttachment: 1,
        FromDownload: 2
    },
    NotificationType: {
        //Thông báo nhắc hạn thanh toán /// </summary> /// Từ attachment của email /// <summary> /// </summary> /// Từ việc đi download nhờ việc phân tích nội dung email /// <summary>
        PaymentWarning: 1,
        CheckingInvoice: 2,
        TaxaxionSync: 3,
        ConnectTax: 4,
        LostConnectTaxaxion: 5,
        ProcessingSyncData: 6,
        DataTaxaxionSync: 7,
        ChangeStatusInvoice: 8,
        RiskSupplier: 9,
        MoveInvoiceInfo: 100
    },
    InvoiceInfoStatusFlags: {
        /// <summary>
        /// Tất cả
        /// </summary>
        All: 0, /// Hóa đơn đang chờ kiểm tra /// <summary>
        /// </summary>
        WaitChecking: 1, /// Hóa đơn hợp lệ /// <summary>
        /// </summary>
        Valid: 2, /// Hóa đơn không hợp lệ /// <summary>
        /// </summary>
        Invalid: 16, /// Hóa đơn chưa thực hiện kiểm tra xong hết các chỉ tiêu /// <summary>
        /// </summary>
        Uncompleted: 24, /// Hóa đơn nháp /// <summary>
        /// </summary>
        InvoiceDraft: 8, /// Cờ chỉ dùng để lọc hóa đơn không có bản thể hiện pdf /// <summary>
        /// </summary>
        NoHasPdf: 999, /// Cờ dùng lọc hóa đơn không có file xml /// <summary>
        /// </summary>
        NoHasXml: 998, /// Cờ dùng lọc hóa đơn có file xml /// <summary>
        /// </summary>
        HasXml: 997, /// Hóa đơn rủi ro /// <summary>
        /// </summary>
        Risky: 30, /// Hóa đơn rủi ro /// <summary>
        /// </summary>
        NoRisky: 29, /// Không kiểm tra /// <summary>
        /// </summary>
        NotNeedCheck: 31
    },
    ViewGuideLiveChat: {
        /// <summary>
        /// Hướng dẫn đầu tiên của live chat
        /// </summary>
        Start: 1,
        EndStart: 2,
        StartGuideLiveChat: 3,
        EndGuideLiveChat: 4
    },
    ChartType: { StackedBarLineChart: 1, LineChart: 2, DoughnutChart: 3, UncheckChart: 4 },
    FileTypeDownloadInvoice: { All: 1, Pdf: 2, Xml: 3, Attachment: 4, PdfAndXml: 5 },
    FileInFolder: { OneFileInOneFolder: 1, AllFileInOneFolder: 2 },
    FileTypeUpload: { Xml: 1, Pdf: 2 },
    FileUploadStatus: {
        /// <summary> /// </summary> /// Đã hướng dẫn xong hướng dẫn đầu /// <summary> /// </summary> /// Hướng dẫn việc bắt đầu đóng live chat phía dưới (đã được chuyển vào live chat phía trên) /// <summary> /// </summary> /// Hướng dẫn việc đóng live chat phía dưới (đã được chuyển vào live chat phía trên) /// <summary>
        /// Upload thành công
        /// </summary>
        Success: 1,
        Fail: 2,
        Invalidate: 3
    },
    ConntectTaxaxionStatus: { Today: 1, ThisWeek: 2, SevenDay: 3, Last30Day: 4 },
    ConntectTaxaxionInvoiceType: { Invoice: 1, OutInvoice: 2 },
    MisaNotificationType: {
        //Tất cả /// </summary> /// Upload thất bại /// <summary> /// </summary> /// File upload không hợp lệ /// <summary>
        All: 1,
        Action: 2,
        System: 3,
        Discount: 4
    },
    StatusStick: {
        All: 0,
        InvoiceOriginal: 1,
        InvoiceReplace: 2,
        InvoiceAdjust: 3,
        InvoiceReplaced: 4,
        InvoiceAdjusted: 5,
        InvoiceCancel: 6,
        InvoiceUnknow: 7
    },
    StatusStickReport: {
        All: 0,
        InvoiceOriginal: 1,
        InvoiceReplace: 2,
        InvoiceAdjust: 3,
        InvoiceReplaced: 4,
        InvoiceAdjusted: 5,
        InvoiceUnknow: 7,
    },
    RiskStatus: { All: 0, NoRisky: 1, Risky: 2, NotEnough: 3, RiskyActiveStatus: 4, RiskyAndRiskyActiveStatus: 5 },
    /** //Hoạt động //Hệ thống //Khuyến mại // Rủi ro theo công văn // Rủi ro theo tình trạng hoạt động 06 // Vừa rủi ro theo công văn vừa rủi ro theo tình trạng hoạt động 06
     * Dùng cho combobox lọc nên không có không đủ điều kiện
     */
    RiskStatusCombobox: { All: 0, NoRisky: 1, Risky: 2 },
    AgreementType: { None: -1, All: 0, TermOfService: 1, Privacy: 2, TermsOfPurchase: 3 },
    InsertStatus: { None: 0, Success: 1, Fail: 2, Duplicate: 3 },
    TChatTBao: { Moi: 0, Huy: 1, DieuChinh: 2, ThayThe: 3, GiaiTrinh: 4, SaiSotDoTongHop: 5 },
    TaxReductionType: {
        /// <summary> /// </summary> /// Thành công /// <summary> /// </summary> /// Thất bại /// <summary> /// </summary> /// Trùng /// <summary>
        /// Không phân biết được
        /// </summary>
        None: -1,
        NQ43: 0,
        NQ101: 1,
        Unknow: 2
    },
    OrderType: {
        /// <summary> /// </summary> /// Nghị quyết số 43/2022/QH15 /// <summary> /// </summary> /// Nghị quyết số 101/2023/QH15 /// <summary> /// </summary> /// Chưa biết, chưa hỗ trợ /// <summary>
        /// Gia hạn
        /// </summary>
        Extend: 1,
        BuyMore: 2,
        Upgrade: 3
    },
    SettingSystemInvoiceName: {
        SellerTaxCode: 1,
        TemplateNo: 2,
        Series: 3,
        InvoiceNo: 4,
        InvoiceDate: 5,
        SupplierName: 6,
        InvoiceNote: 7,
        BuyerName: 8,
        BuyerTaxCode: 9,
    },
    ViewInvoiceDetail: { None: 0, Default: 1, SupplierTemplate: 2 },
    TypeCheckHistory: {
        BuyerName: 1,
        BuyerTaxCode: 2,
        BuyerAddress: 3,
        SellerName: 4,
        SellerAddress: 5,
        Signature: 6,
        ExistTCT: 7,
        StatusInvoice: 8,
        Logic: 9,
        CheckingAdvance: 10
    },
    /**
     * Enum các loại báo cáo trong hệ thống
     * @author Team InvoiceBot
     */
    ReportType: {
        InvoiceSupplierRisk: 1, // Báo cáo hóa đơn rủi ro theo NCC
        InvoiceSupplierActive: 2, // Báo cáo hóa đơn theo tình trạng hoạt động NCC
        InvoiceRelated: 3, // Báo cáo hóa đơn liên quan (thay thế, điều chỉnh)
        InvoiceGeneralPurchase: 4, // Bảng kê hóa đơn mua vào tổng hợp
        InvoiceDetailPurchase: 5, // Bảng kê hóa đơn mua vào chi tiết
        CostSummary: 6, // Báo cáo tổng hợp chi phí
        InvoiceStick: 7, // Báo cáo thống kê chi phí theo nhãn dán
        InvoiceListForStick: 8, // Danh sách hóa đơn theo nhãn dán
        CheckBusiness: 9, // Báo cáo kiểm tra doanh nghiệp
        ReportExceedCost: 10, // Báo cáo hóa đơn vượt định mức chi phí
        ReportOverCost: 11, // Báo cáo hóa đơn quá mức chi phí
        ReportTypeAndCost: 12, // Báo cáo loại chi phí và định mức
        LstInvoiceByTypeAndCost: 13, // Danh sách HĐ theo loại chi phí và định mức
        /**
         * Báo cáo hóa đơn vượt 5 triệu đồng/ngày
         * Theo nghị định về theo dõi giao dịch trên 5 triệu đồng
         * @author dqduy 11.2025
         */
        ReportExceedFiveMillion: 14,
        ReportExceedFiveMillionDetail: 15
    },
    /**
     * Enum cho các nhóm báo cáo - Phân loại báo cáo theo nghiệp vụ
     * Sử dụng để nhóm các báo cáo trên giao diện
     * @author dqduy 11.2025
     */
    ReportGroupType: {
        /**
         * Nhóm 1: Bảng kê hóa đơn đầu vào
         * Bao gồm: Bảng kê tổng hợp, Bảng kê chi tiết
         */
        InvoiceList: 1,
        /**
         * Nhóm 2: Kiểm soát rủi ro đầu vào
         * Bao gồm: Báo cáo HĐ thay thế/điều chỉnh, HĐ rủi ro theo NCC, HĐ theo tình trạng hoạt động NCC
         */
        RiskControl: 2,
        /**
         * Nhóm 3: Quản lý chi phí đầu vào
         * Bao gồm: Thống kê chi phí theo nhãn, Tổng hợp chi phí, Loại chi phí và định mức, HĐ vượt định mức
         */
        CostManagement: 3
    },
    /** //Tên người mua //MST người mua //Địa chỉ người mua //Tên người bán //Địa chỉ người bán //Chữ ký số //Tồn tại trên thuế //Trạng thái hóa đơn //Tính toán chính xác số liệu //Kiểm tra nâng cao //Hóa đơn mua vào tổng hợp //Hóa đơn mua vào tổng hợp // tổng hợp chi phí //Báo cáo chi phí theo nhãn dán // Danh sach chi tiết hóa đơn theo báo cáo nhãn dán /// </summary> /// Mua thêm /// <summary> /// </summary> /// Đổi gói, nâng cấp /// <summary> /// </summary> /// Mẫu mặc định /// <summary> /// </summary> /// Bản thể hiện(pdf, image) /// <summary>
     * Các loại toán tử so sánh trong filter
     */
    FilterOperator: {
        Contains: 'contains',
        NotContains: 'notcontains',
        Equals: '=',
        NotEquals: '<>',
        StartWith: 'startwith',
        EndWith: 'endwith',
        LessThan: '<',
        LessThanOrEqual: '<=',
        GreaterThan: '>',
        GreaterThanOrEqual: '>=',
        In: 'in',
        NotIn: 'notin',
        Between: 'between',
        Blank: 'blank',
        NotBlank: 'notblank',
        IsNull: 'isnull',
        IsNotNull: 'notnull'
    },
    /** //Chứa //Không chứa //Bằng //Không bằng //Bắt đầu với //Kết thúc với //Nhỏ hơn //Nhỏ hơn hoặc bằng //Lớn hơn //Lớn hơn hoặc bằng //Trong //Không trong //Giữa khoảng //Trống //Không trống //Trống //Không trống //InvoiceStatusFilter: { All: 0, WaitChecking: 1, Valid: 2, Invalid: 16, NotNeedCheck: 31,  }
     * Enum filter header dựa trên enum InvoiceStatus
     */
    InvoiceStatusFilter: {
        All: 0,
        WaitChecking: 1,
        Valid: 2,
        NotNeedCheck: 31,
        InvalidBuyerInfo: 32,
        InvalidSellerInfo: 33,
        InvalidGeneralInfo: 34,
        InvalidItems: 35,
        InvalidPaymentInfo: 36,
        InvalidSignInfo: 37,
        CheckWidthTCT: 38,
        InvalidInvoiceInstead: 39,
        InvalidInvoiceAdjust: 40
    },
    /**
     * Enum filer cột Mã cơ quan thuế
     */
    FilterMCQT: { All: 0, IsNull: 1, NotNull: 2 },
    /**
     * Bộ lọc ở cột bản thể hiện hóa đơn
     */
    InvoiceHasPdfFilter: { All: 0, NoPdf: 1, HasPdf: 2, HasXmlNoPdf: 5, HasPdfNoXml: 6, HasXmlHasPdf: 7 },
    /**
     * Bộ lọc ở cột xml hóa đơn
     */
    InvoiceHasXmlFilter: { All: 0, NoXml: 3, HasXml: 4, HasXmlNoPdf: 5, HasPdfNoXml: 6, HasXmlHasPdf: 7 },
    FilterTypeEnum: { AND: 1, OR: 2 },
    /**
     * Enum thể hiện trạng thái kiểm tra thuế suất gán vào combobox
     */
    CheckingVatStatusFlagsFilter: {
        All: -1,
        None: 0,
        Exact: 1,
        UnExact: 2,
        Checking: 3,
        ErrorCheckingVat: 24,
        Accept: 5
    },
    AmountPaymentFilter: { All: -1, Nothing: 0, NotPair: 1, PairAll: 2, PairOutOfDate: 3, PairWarning: 4, PairPart: 5 },
    InvoiceType: {
        /// <summary>
        /// Hóa đơn có mã
        /// </summary>
        WithCode: 1,
        WithoutCode: 2,
        RegisterCash: 3, /// Hóa đơn theo Nghị định 123 /// <summary> /// </summary> /// Hóa đơn không mã /// <summary> /// </summary> /// Hóa đơn máy tính tiền /// <summary>
        /// </summary>
        Decree123: 'Decree123', /// Hóa đơn theo Nghị định 70 /// <summary>
        /// </summary>
        Decree70: 'Decree70', /// Biên lai theo Nghị định 70 /// <summary>
        /// </summary>
        ReceiptDecree70: 'ReceiptDecree70'
    },
    /**
     * loại danh sách của hóa đơn đầu vào, hóa đơn đầu ra hay tờ khai
     */
    ListType: { Invoice: 1, OutInvoice: 2, Declaration: 3 },
    KyHieuMauSoEnum: { GTGT: 1, BanHang: 2, TSanCong: 3, DTruQuocGia: 4, Khac: 5, ChungTuNhuHDon: 6 },
    ViewCheckingResult: {
        /// <summary> //Hóa đơn giá trị gia tăng //Hóa đơn bán hàng // Hóa đơn bán tài sản công //Hóa đơn bán hàng dự trữ quốc gia //Hóa đơn khác //Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn
        /// Kiểm tra chi tiết bản cũ
        /// </summary>
        Normal: 1,
        Advance: 2
    },
    CommodityAcceptStatus: {
        /// <summary> /// </summary> /// Kiểm tra chi tiết nâng cao bản mới /// <summary>
        /// Dòng chi tiết là dịch vụ (theo Nghị định 123/2020/NĐ-CP)
        /// </summary>
        ItemIsService: 1,
        InvoiceAccordingContract: 2,
        InvoiceAccordingGovernment: 3,
        InvoicePublished: 4,
        /** /// </summary> /// Hóa đơn cho hoạt động xây dựng, lắp đặt, xây nhà để bán có thu tiền theo tiến độ theo hợp đồng (theo Nghị định 123/2020/NĐ-CP) /// <summary> /// </summary> /// Hóa đơn cho hoạt động xây dựng, lắp đặt, sản xuất, cung cấp sản phẩm, dịch vụ của doanh nghiệp quốc phòng an ninh phục vụ hoạt động quốc phòng an ninh theo quy định của Chính phủ (theo Nghị định 123/2020/NĐ-CP) /// <summary> /// </summary> /// Hóa đơn đã phát thành kèm bảng kê liệt kê các hàng hóa, dịch vụ /// <summary>
         * Nguyên nhân khác
         */
        Other: 5
    },
    DashboardRefreshType: {
        // thông kế số lượng hóa đơn
        InvTotal: 1,
        LineTotal: 2,
        ProviderInvTotal: 3
    },
    TabAction: { All: 1, Correct: 2, Inspect: 3 },
    CostTypeEnum: {
        None: 0,
        Electricity: 1,
        Water: 2,
        Telecommunication: 3,
        Postage: 4,
        FinancialExpenses: 5,
        RoadFees: 6,
        Insurance: 7, /// </summary> /// Thuê mặt bằng /// </summary> /// Điện // tình hình nhận hóa đơn // tổng giá trị hóa đơn /// <summary> /// </summary> /// Nước /// <summary> /// </summary> /// Viễn thông /// <summary> /// </summary> /// Bưu phí /// <summary> /// </summary> /// Chi phí tài chính /// <summary> /// </summary> /// Đường bộ /// <summary> /// </summary> /// Bảo hiểm /// <summary> /// <summary>
        Rent: 8, /// </summary> /// Xăng, dầu /// <summary>
        Petroleum: 9, /// </summary> /// Tiếp khách /// <summary>
        ReceivingGuests: 10, /// </summary> /// Lưu trú /// <summary>
        Accommodation: 11, /// </summary> /// Tiếp thị, quảng cáo /// <summary>
        MarketingOrAdvertising: 12, /// </summary> /// Phí gửi xe /// <summary>
        ParkingFee: 14
    },
    CostTypeEnumFilter: {
        All: 0,
        Electricity: 1,
        Water: 2,
        Telecommunication: 3,
        Postage: 4,
        FinancialExpenses: 5,
        RoadFees: 6,
        Insurance: 7, /// </summary> /// Thuê mặt bằng /// </summary> /// Điện // tình hình nhận hóa đơn // tổng giá trị hóa đơn /// <summary> /// </summary> /// Nước /// <summary> /// </summary> /// Viễn thông /// <summary> /// </summary> /// Bưu phí /// <summary> /// </summary> /// Chi phí tài chính /// <summary> /// </summary> /// Đường bộ /// <summary> /// </summary> /// Bảo hiểm /// <summary> /// <summary>
        Rent: 8, /// </summary> /// Xăng, dầu /// <summary>
        Petroleum: 9, /// </summary> /// Tiếp khách /// <summary>
        ReceivingGuests: 10, /// </summary> /// Lưu trú /// <summary>
        Accommodation: 11, /// </summary> /// Tiếp thị, quảng cáo /// <summary>
        MarketingOrAdvertising: 12, /// </summary> /// Phí gửi xe /// <summary>
        ParkingFee: 14
    },
    CostTypeEnumGrid: {
        //Tất cả
        All: 999,
        Electricity: 1,
        Water: 2,
        Telecommunication: 3,
        Postage: 4,
        FinancialExpenses: 5,
        RoadFees: 6,
        Insurance: 7, /// </summary> /// Thuê mặt bằng /// </summary> /// Điện /// <summary> /// </summary> /// Nước /// <summary> /// </summary> /// Viễn thông /// <summary> /// </summary> /// Bưu phí /// <summary> /// </summary> /// Chi phí tài chính /// <summary> /// </summary> /// Đường bộ /// <summary> /// </summary> /// Bảo hiểm /// <summary> /// <summary>
        Rent: 8, /// </summary> /// Xăng, dầu /// <summary>
        Petroleum: 9, /// </summary> /// Tiếp khách /// <summary>
        ReceivingGuests: 10, /// </summary> /// Lưu trú /// <summary>
        Accommodation: 11, /// </summary> /// Tiếp thị, quảng cáo /// <summary>
        MarketingOrAdvertising: 12, /// </summary> /// Phí gửi xe /// <summary>
        ParkingFee: 14,
        None: 0
    },
    /**
     * Lấy danh sách chi phí hay danh sách định mức chi phí
     */
    CostActionTypeEnum: {
        /// <summary>
        /// Danh sách phân loại chi phí
        /// </summary>
        Classification: 1, /// </summary> /// Danh sách định mức chi phí /// <summary>
        CostNorms: 2, /// Danh sách phân loại chi phí theo thời gian /// <summary>
        /// </summary>
        CostTypeInvoiceByTime: 3
    },
    Screen: { W1920: 1920, W1600: 1600, W1280: 1280, W1024: 1024, H1080: 1080, H900: 900, H768: 768 },
    JobType: {
        None: 'None',
        Connect: 'Connect',
        InMaster: 'InMaster',
        OutMaster: 'OutMaster',
        Detail: 'Detail',
        Download: 'Download',
        SearchTax: 'SearchTax',
        StatisticInMaster: 'StatisticInMaster',
        StatisticOutMaster: 'StatisticOutMaster',
        StatisticInConnectInvoiceDetail: 'StatisticInConnectInvoiceDetail',
        StatisticOutConnectInvoiceDetail: 'StatisticOutConnectInvoiceDetail',
        ShowNps: 'ShowNps',
        SendNps: 'SendNps',
        CancelNps: 'CancelNps',
        LostConnection: 'LostConnection',
        InsertDatabase: 'InsertDatabase',
        UpdateDatabase: 'UpdateDatabase',
        DeleteDatabase: 'DeleteDatabase',
        QueryDatabase: 'QueryDatabase',
        StatisticViewDetailAdvantage: 'StatisticViewDetailAdvantage',
        Translate: 'Translate',
        TraceRequest: 'TraceRequest',
        StatisticViewDetailPredictVatRateAVA: 'StatisticViewDetailPredictVatRateAVA',
        OcrRequest: 'OcrRequest',
        /**
         * Giải thích hóa đơn bằng AVA (AI Assistant)
         */
        ExplainInvoiceByAVA: 'ExplainInvoiceByAVA',
        /**
         * Kiểm tra ngành nghề kinh doanh bằng AVA
         */
        CheckBusinessByAva: 'CheckBusinessByAva',
        /**
         * Phân loại chi phí bằng AVA
         */
        CostTypeByAva: 'CostTypeByAva'
    },
    InvoiceDetailType: { InvoiceList: 1, ReportSupplierActiveList: 2 },
    ViewNoti: { All: 0, NotView: 1 },
    ImportType: { Supplier: 1, SupplierNoDownloadInvoice: 2 },
    YesNo: { All: 0, Yes: 1, No: 2, Blank: 3 },
    UpdateType: { Increase: 1, Decrease: 2 },
    InvalidAccecptType: {
        BuyerName: 1,
        BuyerAddress: 2,
        SellerName: 3,
        SellerAddress: 4,
        ExchangeRate: 5,
        UnitName: 6,
        Quantity: 7,
        UnitPrice: 8,
        TaxInfo: 9,
        Signature: 10,
        CheckWithTCT: 11
    },
    TypeRedirectFunction: { Router: 1, Popup: 2 },
    ReportSupplierActiveType: {
        /// <summary>
        /// Tình trạng HĐ của NCC mới nhất
        /// </summary>
        Lastest: 1, /// </summary> /// Tình trạng HĐ của NCC theo ngày hóa đơn /// <summary>
        InvoiceDate: 2
    },
    FormType: { ReportSupplierActive: 1 },
    NodeEnv: { Development: 'development', Production: 'production' },
    StatusUpdateInvDetail: { Unknown: 0, Success: 1, Fail: 2, Processing: 3 },
    InvoiceInfoDetailSyncTaxResponseEnum: { Success: 0, DisconnectTax: 1 },
    NavigationType: {
        Chorme: 'GoogleChrome',
        Edge: 'MicrosoftEdge',
        Firefox: 'MozillaFirefox',
        Safari: 'AppleSafari',
        Trident: 'MicrosoftInternetExplorer',
        Unknown: 'Unknown'
    },
    Postion: { RightTop: 1, RightBottom: 2, LeftTop: 3, LeftBottom: 4 },
    StatusDownloadInvoice: {
        All: 0,
        TotalInvoiceifference: 1,
        TotalDownloadSuccess: 2,
        TotalDownloadFail: 3,
        TotalInvoiceProcessing: 4,
        TotalInvoiceIgnore: 5,
        TotalInvoiceSuccess: 6,
        TotalInvoiceDuplicate: 7
    },
    InstructionVideoType: {
        All: 1,
        Overview: 2,
        CreateEmailToReceiveInvoices: 3,
        AddInvoicesToTheSoftware: 4,
        ProcessCheckTheValidityOfTheInvoice: 5,
        OtherSettings: 6,
        ViewReport: 7,
        ConnectToAccountingSoftware: 8
    },
    IntructionStepType: {
        Overview: 1,
        CreateEmailToReceiveInvoices: 2,
        AddInvoicesToTheSoftware: 3,
        ProcessCheckTheValidityOfTheInvoice: 4,
        OtherSettings: 5,
        ViewReport: 6,
        ConnectToAccountingSoftware: 7
    },
    CriteriaDefine: {
        Unknow: -1,
        Buyer: 0,
        BuyerName: 1,
        BuyerTaxCode: 2,
        BuyerAddress: 3,
        SellerName: 4,
        SellerAddress: 5,
        SellerTaxCode: 6,
        Seller: 7,
        GeneralInformation: 8,
        InvoiceNo: 9,
        InvoiceDate: 10,
        Series: 11,
        TemplateNo: 12,
        SignatureDateGeneralInformation: 13,
        IssueDate: 14,
        CcyCode: 15,
        ExchangeRate: 16,
        Commodity: 17,
        ItemName: 18,
        UnitName: 19,
        Quantity: 20,
        UnitPrice: 21,
        TotalAmount: 22,
        VatRate: 23,
        Payment: 24,
        PaymentVatRate: 25,
        TotalAmountNumber: 26,
        TotalAmountWord: 27,
        PaymentMethod: 28,
        RelatedInvoiceDate: 29,
        RelatedInvoiceNo: 30,
        RelatedInvoiceSeries: 31,
        RelatedInvoiceTemplateNo: 32,
        SignatureDate: 33,
        TaxRiskStatus: 34,
        PublishedInvoiceStatus: 35,
        ActiveStatus: 36,
        TaxaxionSignature: 37,
        DataWasModified: 38,
        HasSigned: 39,
        SellerSignatureStatus: 40,
        Certificate: 41,
        SellerSignedDate: 42,
        SellerDataWasModified: 43,
        SellerCertificateOwner: 44,
        SignedDateEqInvoiceDate: 45,
        SellerCertificate: 46,
        CertificateOwner: 47,
        SellerHasSigned: 49,
        StatusExistTCT: 50,
        StopUsingTaxaxion: 52,
        InvoiceName: 53,
        CostNorms: 54,
        CheckLogic: 55,
        VatRateAVA: 56,
        BusinessIndustry: 57,
        XmlInfo: 58,
        RelatedStatementNo: 59,
        RelatedStatementDate: 60, /// Tiêu chí kiểm tra hàng hóa đặc trưng theo NĐ 70 /// <summary> // chưa tải được hóa đơn // tải thành công // tải thất bại // đang tải // bỏ qua // hóa đơn đang xử lý // hóa đơn trùng //Tính toán số liệu //Kiểm tra thuế suất //Kiểm tra ngành nghề kinh doanh //Kiểm tra XML //Số bảng kê // Ngày bảng kê
        /// </summary>
        CharacteristicGoods: 61,
        CompareTotalWordWithNumber: 62,
        BusinessLocation: 63, /// Tiêu chí kiểm tra địa điểm kinh doanh HKD/CNKD theo Nghị định 141/2026/NĐ-CP
        /// Tiêu chí khác, chưa xác định là gì, tiêu chí chung chung /// <summary>
        /// Định nghĩa enum này ở cuối
        /// </summary>
        Other: 999
    },
    AvaQuestionType: { Summary: 1, ExplainDetail: 2, Regulation: 3, Instruction: 4 },
    /**
     * Hành xử trên từng ngành nghề kinh doanh
     */
    ActionItemBusiness: { None: 0, Like: 1, Dislike: 2 },
    /**
     * Trạng thái của từng ngành nghề mà AVA trả ra
     */
    StatusCheckBusiness: { None: -1, NotFound: 0, Accept: 1 },
    KindReview: {
        None: 0,
        Like: 1,
        Unlike: 2,
        Dislike: 3,
        UnDislike: 4, /// Bỏ đánh giá không hữu ích /// <summary>
        /// </summary>
        UnDislike: 4, /// Tóm tắt /// <summary>
        /// </summary>
        Introduction: 5, /// Hướng dẫn /// <summary>
        /// </summary>
        Instruction: 6, /// Quy định /// <summary>
        /// </summary>
        Regulation: 7, /// Giải thích chi tiết /// <summary>
        /// </summary>
        Explaination: 8, /// Chọn chỉ tiêu ở danh sách(Để hỏi AVA) /// <summary>
        /// </summary>
        SelectInvoiceList: 9, /// Chọn chỉ tiêu ở chi tiết(để hỏi AVA) /// <summary>
        /// </summary>
        SelectDetail: 10, /// Thực hiện chat hỏi AVA /// <summary>
        /// </summary>
        ChatAVA: 11, /// Sử dụng tính năng giải thích chi tiết trong chi tiết /// <summary>
        /// </summary>
        ExplainByAVA: 12
    },
    FilterInvoiceList: {
        /// <summary>
        /// Ngày hóa đơn
        /// </summary>
        InvoiceDate: 0, /// Ngày vào hệ thống /// <summary>
        /// </summary>
        DateEenteredTheSystem: 1
    },
    TitlebarColor: {
        /// <summary>
        /// Màu ứng dụng (#00A2CF)
        /// </summary>
        App: 0,
        /// <summary>
        /// Màu trắng (#FFFFFF)
        /// </summary>
        White: 1
    },
    SidebarColor: {
        /// <summary>
        /// Màu tối (#10141B)
        /// </summary>
        Dark: 0,
        /// <summary>
        /// Màu trắng (#FFFFFF)
        /// </summary>
        White: 1
    },
    DatePickerTypeSelect: { Month: 0, Quarter: 1, Year: 2 },
    KeyDate: { StartDate: 1, EndDate: 2 },
    ImageTypeVersionFeature: { CheckingResult: 1, Report: 2 },
    RulesShowTooltip: { isUseElastic: 1, isExistsInvRevEmail: 2, isConnectCqt: 3 },
    ColumnValidateType: { MsCellDatePickerV2: 1 },
    TypeMsTagNew: { Report: 1, ConnectInvoice: 2 },
    TypeSupplierConnectInvoice: {
        /**
         * Nhà cung cấp hóa đơn
         */
        InvoiceProvider: 0,
        /**
         * Nhà cung cấp hàng hóa dịch vụ
         */
        GoodsAndServiceProvider: 1,
        /**
         * Thuế
         */
        axaxion: 2
    },
    /**
     * Loại cảnh báo hết tài nguyên
     */
    TypeWarningLicense: { All: 1, Number: 2, Expried: 3, NoLicense: 4 },
    RestoreCustomsDeclare: { NotFound: 1, ExistInOtherOrg: 2 },
    typeCharacteristicGoodsInvalid: {
        CharacteristicGoodsEmpty: 1,
        CharacteristicGoodsInvalid1: 2,
        CharacteristicGoodsInvalid2: 3,
        CharacteristicGoodsInvalid3: 4
    },
    PopupCriteriaOptions: { IsAccept: 1, DisplayInList: 2, IsConclusionInvoiceValid: 3 },
    EmailType: { Normal: 0, Trash: 1, Important: 2, Spam: 3 },
    SubscriberType: {
        /// <summary> //hết cả số lượng và hạn //Hết số lượng //Hết hạn //Không hết liicsense (TH để xử lý khi email hết hạn và mua mới rồi)
        /// Doanh nghiệp
        /// </summary>
        /// <remarks>
        /// Áp dụng cho tổ chức có mã số thuế hợp lệ.
        /// Yêu cầu các thông tin như mã số thuế, tên doanh nghiệp, địa chỉ và email kế toán trưởng.
        /// </remarks>
        Enterprise: 1, /// Công ty kế toán dịch vụ /// <summary>
        /// </summary>
        /// <remarks>
        /// Áp dụng cho các công ty cung cấp dịch vụ kế toán chuyên nghiệp.
        /// Có thể quản lý nhiều khách hàng dưới một tài khoản.
        /// </remarks>
        ServiceAccountCompany: 2, /// Cá nhân làm kế toán dịch vụ /// <summary>
        /// </summary>
        /// <remarks>
        /// Áp dụng cho kế toán viên tự do cung cấp dịch vụ kế toán.
        /// Yêu cầu thông tin cá nhân của kế toán viên.
        /// </remarks>
        ServiceAccountIndividual: 3, /// Hộ kinh doanh /// <summary>
        /// </summary>
        /// <remarks>
        /// Áp dụng cho hộ kinh doanh cá thể có đăng ký kinh doanh.
        /// Yêu cầu các thông tin như CCCD chủ hộ, mã số thuế (nếu có), và email đại diện.
        /// </remarks>
        BusinessHousehold: 4
    },
    CustomerType: {
        /// <summary>
        /// Hộ kinh doanh
        /// </summary>
        HKD: 'HKD', /// Doanh nghiệp /// <summary>
        /// </summary>
        DN: 'DN'
    },
    InvoiceDecreeType: { Unknown: 0, Decree123: 1, Decree70: 2, ReceiptDecree70: 3, ND254: 4 },
    ViewInfoType: { ViewAll: 1, ViewSelected: 2 },
    VatRateEnum: {
        /// <summary>
        /// Thuế suất 10%
        /// </summary>
        Vat10: 10, /// <summary>
        /// Thuế suất 8%
        /// </summary>
        Vat8: 8, /// <summary>
        /// Thuế suất 5%
        /// </summary>
        Vat5: 5, /// <summary>
        /// Thuế suất 0%
        /// </summary>
        Vat0: 0, /// <summary>
        /// Không chịu thuế (KCT)
        /// </summary>
        NotSubjectToVat: -1, /// <summary>
        /// Thuế khai thay
        /// </summary>
        DeclaredTax: -2, /// <summary>
        /// Thuế cho thuê tài chính
        /// </summary>
        FinancialLeasingVat: 50, /// <summary>
        /// Không thuộc phạm vi điều chỉnh của Luật thuế (KTPVDC) theo NĐ254
        /// </summary>
        KTPVDC: -5, /// <summary>
        /// Không tính vào giá tính thuế GTGT (KTGTT) theo NĐ254
        /// </summary>
        KTGTT: -6, /// <summary>
        /// Thuế suất khác
        /// </summary>
        OtherVat: 100, /// <summary>
        /// Thuế suất không xác định (mã thuế suất mới/chưa có quy tắc — PBI 671193)
        /// Chỉ đọc nguyên văn giá trị từ XML/CQT, không tính lại tiền thuế, không làm dòng điều chỉnh
        /// </summary>
        VatRateUnknown: -10
    },
    NotificationTypeOrder: {
        CheckLoginTaxation: 1,
        NotificationTaxaxion: 2,
        CheckingInvoice: 3,
        InvPaymentWarning: 4,
        LostConnectTaxaxion: 5,
        InvoiceRiskBySupplier: 6
    },
    AbbreviationEnum: {
        XuatNhapKhau: 1,
        ThuongMai: 2,
        DichVu: 3,
        TrachNhiemHuuHan: 4,
        CoPhan: 5,
        SanXuat: 6,
        XiNghiep: 7,
        TongCongTy: 8,
        XayDung: 9,
        HopTacXa: 10,
        VietNam: 11,
        Tinh: 12
    },
    UpdateStatusEnum: {
        /// <summary>
        /// Trạng thái không xác định
        /// </summary>
        Unknown: 0, /// Cập nhật thành công /// <summary>
        /// </summary>
        Success: 1, /// Cập nhật thất bại /// <summary>
        /// </summary>
        Fail: 2, /// Đang trong quá trình cập nhật /// <summary>
        /// </summary>
        Processing: 3
    },
    InvalidConditionCompareEnum: { OutOfNumberAllow: 1, InvalidTimeRange: 2 },
    TrendStatus: { Unknown: 0, Up: 1, Down: 2, Flat: 3 },
    /**
     * Enum chế độ lọc nhà cung cấp khi tải hóa đơn từ CQT
     * Created by HVANH on 29/01/2025 - PBI-543289
     *
     * @remarks
     * - ExcludeSuppliers (1): Bỏ qua NCC được chọn (blacklist mode) - MẶC ĐỊNH
     * - OnlySelectedSuppliers (2): CHỈ tải NCC được chọn (whitelist mode)
     */
    SupplierFilterModeEnum: {
        /**
         * Bỏ qua một số nhà cung cấp (không tải hóa đơn từ NCC này)
         * Chế độ blacklist: Tải tất cả NCC TRỪ những NCC được chọn
         */
        ExcludeSuppliers: 1,
        /**
         * Chỉ tải về hóa đơn từ nhà cung cấp được chọn
         * Chế độ whitelist: CHỈ tải NCC được chọn, bỏ qua tất cả NCC khác
         */
        OnlySelectedSuppliers: 2
    },
    CompareType: {
        /// <summary>
        /// So sánh với kỳ trước liền kề
        /// </summary>
        /// <example>
        /// Q3/2025 → Q2/2025
        /// Q1/2025 → Q4/2024
        /// </example>
        Previous: 0,

        /// <summary>
        /// So sánh với cùng kỳ năm trước
        /// </summary>
        /// <example>
        /// Q3/2025 → Q3/2024
        /// Q1/2025 → Q1/2024
        /// </example>
        SameLastYear: 1
    },
    TypeInvoiceReport: {
        All: 0,
        OnlyVatInvoice: 1
    },
    AssistantPanelType: {
        //Nhắc nhở Kết nối với hoadondientu.gdt.gov.vn 
        ConnectGovLink: 1,

        //Nhắc nhở "Đồng bộ hóa đơn từ cơ quan thuế về phần mềm" (1)
        InitiAtiveConnect: 2,

        //Khuyến nghị "Bạn bị thiếu hóa đơn do đâu?" 
        ConnectTaxMissInvoice: 3,

        //Khuyến nghị "Quản lý rủi ro và tình trạng hoạt động của nhà cung cấp" (2) 
        ManageSellerRisk: 4,

        //Mất kết nối Thuế
        DisconnectTaxaxion: 5,
    },
    /**
     * Loại vấn đề với hóa đơn thu thập
     */
    IssueType: {
        All: 999,
        None: 0,
        CannotDownloadPdf: 1,
        CannotReadPdf: 2
    },

    TypeImageYoutube: {
        None: 0,
        MaxResDefault: 1,
        SdDefault: 2,
        HqDefault: 3,
        MqDefault: 4,
        Default: 5
    }
};